<template>
  <div id="landingcontainer">
    <div class="row">
      <div class="s12 col">
        <div class="row row-condense">
          <div class="card_container_static">
            <div class="square_card">
              <div class="squared invisible">nbsp;</div>
            </div>
          </div>
          <div v-for="(colscore, index) in colNumbers" :key="index" class="card_container_static">
            <NumberSquare type="col" :num="colscore" />
          </div>
        </div>
        <div v-for="(rowscore, index) in rowNumbers" :key="index" class="row row-condense">
          <div class="card_container_static">
            <NumberSquare type="row" :num="rowscore" />
          </div>
          <span v-for="(name, index) in randomNames[index]" :key="index">
            <GridSquare :name="name" :col="colNumbers[index]" :row="rowscore" />
          </span>
        </div>
        <div class="row row-condense">
          <div class="card_container_static">
            <div class="square_card">
              <div class="squared invisible">nbsp;</div>
            </div>
          </div>
          <div v-for="(colscore, index) in colNumbers" :key="index" class="card_container_static">
            <NumberSquare type="col" :num="colscore" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NumberSquare from '@/components/NumberSquare.vue'
import GridSquare from '@/components/GridSquare.vue'

export default {
  components: {
    NumberSquare,
    GridSquare
  },
  data () {
    return {
      scores: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
      row_num: null,
      col_num: null,
      old_row: 0,
      old_col: 0,
      rowNumbers: [],
      colNumbers: [],
      names: ['Neida', 'Hoyt', 'Glenn', 'Dallas', 'Cornelius', 'Lurline', 'Damien', 'Gordon', 'Rosario', 'Alishia', 'Steffanie', 'Kymberly', 'Douglas', 'Johnie', 'Keli', 'Percy', 'Hermine', 'Anderson', 'Clarine', 'Mitchell', 'Ricardo', 'Rina', 'Foster', 'Billie', 'Kimi', 'Verena', 'Weston', 'Major', 'Benito', 'Karol', 'Pamala', 'Regenia', 'Theo', 'Monet', 'Marcelo', 'Juliet', 'Marlo', 'Raleigh', 'Devon', 'Raymond', 'Bradford', 'Domonique', 'Donny', 'Serafina', 'Nedra', 'Julius', 'Bryant', 'Albert', 'Madison', 'Denny', 'Emerald', 'Lois', 'Grady', 'Kermit', 'Mel', 'Kellie', 'Charles', 'Reynalda', 'Judy', 'Dessie', 'Darren', 'Fermina', 'Petra', 'Columbus', 'Phung', 'Cletus', 'Travis', 'Martin', 'Lani', 'Marleen', 'Floy', 'William', 'Glynda', 'Carina', 'Dusty', 'Casimira', 'Margaret', 'Kay', 'Launa', 'Hee', 'Kirk', 'Sherley', 'Jamal', 'Austin', 'James', 'Nikia', 'Jared', 'Errol', 'Hyman', 'Adriene', 'Keiko', 'Orpha', 'Johnette', 'Particia', 'Waldo', 'Adrian', 'Quentin', 'Jeffry', 'Richard', 'Gaylord'],
      indexShift: 0,
      randomNames: {}
    }
  },
  methods: {
    shuffle (array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]]
      }
      return array
    },
    shuffleScores () {
      this.rowNumbers = this.shuffle([...this.scores])
      this.colNumbers = this.shuffle([...this.scores])
    },
    shuffleNames (array) {
      for (let i = 0; i < 10; i++) {
        let start = i * 10
        this.randomNames[i] = this.shuffle(this.names.slice(start, start + 10))
      }
    },
    flipSquare (elementId, klass) {
      let elements = document.querySelectorAll(elementId)
      for (let i = elements.length - 1; i >= 0; i--) {
        elements[i].classList.add(klass)
      }
    },
    unflipSquare (elementId, klass) {
      let elements = document.querySelectorAll(elementId)
      for (let i = elements.length - 1; i >= 0; i--) {
        elements[i].classList.remove(klass)
      }
    },
    randomFlip (oldNum) {
      let newNum = this.scores[Math.floor(Math.random() * this.scores.length)]
      while (newNum === oldNum) {
        newNum = this.scores[Math.floor(Math.random() * this.scores.length)]
      }
      return newNum
    },
    unflip (row, col) {
      this.unflipSquare(`.row_${row}`, 'flip')
      this.unflipSquare(`.col_${col}`, 'flip')
      this.unflipSquare(`#gridsquare_r${row}c${col}`, 'flip')
    },
    flip (row, col) {
      this.flipSquare(`.row_${row}`, 'flip')
      this.flipSquare(`.col_${col}`, 'flip')
      this.flipSquare(`#gridsquare_r${row}c${col}`, 'flip')
      this.old_row = row
      this.old_col = col
    },
    startFlipSequence () {
      setInterval(() => {
        this.unflip(this.old_row, this.old_col)
        this.row_num = this.randomFlip(this.row_num)
        this.col_num = this.randomFlip(this.col_num)
        this.flip(this.row_num, this.col_num)
      }, 5000)
    }
  },
  mounted () {
    this.shuffleScores()
    this.shuffleNames()
    this.startFlipSequence()
  }
}
</script>
